import { env } from './index';

export function isServer() {
  return typeof window === 'undefined' && typeof global !== 'undefined';
}

export function isClient() {
  return typeof window !== 'undefined';
}

/**
 * Check if the current environment is development or staging
 * @returns {boolean} True if environment is development or staging
 */
export function isDevOrStaging() {
  if (env('NEXT_PUBLIC_ENV')) {
    return ['DEV', 'STAGING'].includes(env('NEXT_PUBLIC_ENV'));
  }

  return env('NODE_ENV') === 'development';
}

/**
 * Get media origin URL based on environment
 * @returns {string} Media origin URL
 */
export function getMediaOrigin(): string {
  return env('NEXT_PUBLIC_ENV_MEDIA_ORIGIN') || 'https://dev-media.skin-seoul.com';
}
